<template>
  <div class="container mt-4" dir="rtl">
       <UserWelcome 
      :userName="'أ. محمد أحمد'" 
      userRole="usercontrol"
      :entityName="committee_name" 
    />
    <!-- عنوان الصفحة (محسن للموبايل) -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 text-center text-md-end">
      <h4 class="fw-bold text-primary mb-2 mb-md-0">
        <i class="fas fa-network-wired ms-2"></i> غرفة عمليات اللجنة
      </h4>
      <!-- <div class="text-muted small bg-light px-3 py-2 rounded-pill shadow-sm">
        <i class="fas fa-user ms-1"></i> مرحباً، رئيس اللجنة {{ committee_name }}
      </div> -->
    </div>

    <!-- الصف الرئيسي -->
    <div class="row g-4"> <!-- g-4 يضيف مسافة بين الأعمدة المتجاورة -->
      
      <!-- ============================================= -->
      <!-- الجزء العلوي في الموبايل / الأيمن في الديسك توب: التعليمات -->
      <!-- order-2 order-md-1: لكي تظهر التعليمات أولاً في الشاشات الكبيرة، ولكن قد نريد البلاغ أولاً في الموبايل -->
      <!-- ============================================= -->
      <div class="col-12 col-lg-7 mb-3">
        <div class="card shadow-sm h-100 border-top-warning">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 class="text-dark fw-bold mb-0 fs-6 fs-md-5">
              <i class="fas fa-bullhorn ms-2 text-warning"></i> تعليمات الكنترول
            </h5>
            <span v-if="loading" class="spinner-border spinner-border-sm text-primary"></span>
          </div>
          
          <div class="card-body bg-light position-relative custom-scrollbar" style="min-height: 300px; max-height: 600px; overflow-y: auto;">
            
           <div 
  v-for="msg in instructions" 
  :key="msg.id" 
  class="alert shadow-sm mb-3 position-relative p-3" 
  :class="getAlertClass(msg.type)"
>
  <!-- 1. رأس الرسالة (العنوان والتاريخ) -->
  <!-- flex-column للموبايل ليظهرا فوق بعض، flex-sm-row للكمبيوتر ليظهرا بجانب بعض -->
  <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-2 gap-2">
    
    <strong class="d-flex align-items-center">
      <!-- أيقونة ثابتة لا تنكمش -->
      <span class="flex-shrink-0 ms-2">
        <i v-if="msg.type === 'urgent'" class="fas fa-exclamation-triangle text-danger fs-5"></i>
        <i v-else class="fas fa-info-circle text-primary fs-5"></i>
      </span>
      <!-- العنوان -->
      <span class="text-break">{{ msg.title }}</span>
    </strong>

    <!-- التاريخ (يظهر بخط أصغر ولون باهت) -->
    <small class="text-muted bg-white px-2 py-1 rounded border align-self-start align-self-sm-center" style="font-size: 0.75rem; white-space: nowrap;">
      <i class="far fa-clock ms-1"></i> {{ formatDate(msg.created_at) }}
    </small>
  </div>
  
  <!-- 2. محتوى الرسالة -->
  <div class="mb-3 text-dark lh-base" style="white-space: pre-line; font-size: 0.95rem;">
    {{ msg.content }}
  </div>
  
  <!-- 3. ذيل الرسالة (زر الإجراء) -->
  <div class="border-top pt-3 mt-2">
    <!-- w-100 للموبايل ليأخذ الزر العرض الكامل -->
    <div class="d-flex justify-content-end w-100">
      
      <!-- حاوية الزر: 100% في الموبايل، وتلقائي في الشاشات الأكبر -->
      <div class="w-100 w-sm-auto">
        <button 
          v-if="!msg.is_read" 
          @click="markAsRead(msg)" 
          class="btn btn-sm btn-outline-primary w-100 d-flex justify-content-center align-items-center py-2"
          :disabled="msg.processing"
        >
          <span v-if="msg.processing" class="spinner-border spinner-border-sm ms-2"></span>
          <i class="fas fa-check-double ms-2"></i> 
          <span class="fw-bold">تأكيد الاطلاع والعلم</span>
        </button>

        <!-- حالة تم الاطلاع -->
        <div v-else class="alert-success text-success small fw-bold bg-white px-3 py-2 rounded border text-center w-100">
          <i class="fas fa-check-circle ms-1"></i> تم الاطلاع: {{ formatTime(msg.read_at) }}
        </div>
      </div>

    </div>
  </div>
</div>

            <div v-if="!loading && instructions.length === 0" class="text-center text-muted mt-5">
              <i class="fas fa-inbox fa-3x mb-3 text-secondary opacity-50"></i>
              <p>لا توجد تعليمات جديدة اليوم.</p>
            </div>

          </div>
        </div>
      </div>

      <!-- ============================================= -->
      <!-- الجزء السفلي في الموبايل / الأيسر في الديسك توب: إرسال البلاغات -->
      <!-- ============================================= -->
      <div class="col-12 col-lg-5 mb-3">
        
        <!-- نموذج الإرسال -->
        <div class="card shadow-sm border-top-primary mb-3">
          <div class="card-header bg-white">
            <h5 class="text-primary fw-bold mb-0 fs-6 fs-md-5">
              <i class="fas fa-paper-plane ms-2"></i> إرسال بلاغ / شكوى
            </h5>
          </div>
          <div class="card-body">
            
            <form @submit.prevent="sendComplaint">
              <div class="mb-3">
                <label class="form-label fw-bold small">تصنيف البلاغ</label>
                <select v-model="form.type" class="form-select form-select-sm" required>
                  <option value="">-- اختر التصنيف --</option>
                  <option value="administrative">إداري (عجز ملاحظين/عاملين)</option>
                  <option value="security">أمني (شغب / تجمهر)</option>
                  <option value="medical">طبي (حالة مرضية)</option>
                  <option value="papers">أوراق (نقص/تلف أسئلة)</option>
                  <option value="other">أخرى</option>
                </select>
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold small">درجة الأهمية</label>
                <div class="btn-group w-100 btn-group-sm" role="group">
                  <input type="radio" class="btn-check" name="priority" id="p1" value="normal" v-model="form.priority">
                  <label class="btn btn-outline-secondary" for="p1">عادي</label>

                  <input type="radio" class="btn-check" name="priority" id="p2" value="high" v-model="form.priority">
                  <label class="btn btn-outline-warning text-dark" for="p2">هام</label>

                  <input type="radio" class="btn-check" name="priority" id="p3" value="urgent" v-model="form.priority">
                  <label class="btn btn-outline-danger" for="p3">عاجل جداً</label>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label fw-bold small">تفاصيل الموقف</label>
                <textarea v-model="form.description" class="form-control" rows="3" placeholder="اكتب وصفاً دقيقاً..." required></textarea>
              </div>

              <button type="submit" class="btn btn-primary w-100 btn-sm fw-bold py-2" :disabled="sending">
                <span v-if="sending" class="spinner-border spinner-border-sm ms-1"></span>
                <span v-else><i class="fas fa-paper-plane ms-1"></i> إرسال لغرفة العمليات</span>
              </button>
            </form>

          </div>
        </div>

        <!-- سجل البلاغات السابقة -->
        <div class="card shadow-sm mt-3">
          <div class="card-header bg-light py-2 d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-bold text-muted small">سجل بلاغاتي اليوم</h6>
            <span class="badge bg-secondary">{{ complaints.length }}</span>
          </div>
          
          <div class="card-body p-0 custom-scrollbar" style="max-height: 400px; overflow-y: auto;">
            <div class="list-group list-group-flush">
              
              <div v-for="log in complaints" :key="log.id" class="list-group-item p-3">
                
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <span class="fw-bold text-primary small d-block">{{ log.type_text }}</span>
                    <small class="text-muted d-block" style="font-size: 0.7rem;">{{ log.created_at_human }}</small>
                  </div>
                  <span class="badge rounded-pill" :class="getStatusBadge(log.status)" style="font-size: 0.7rem;">
                    {{ log.status_text }}
                  </span>
                </div>

                <p class="mb-2 text-dark small bg-light p-2 rounded border">
                  {{ log.description }}
                </p>

                <div v-if="log.admin_response" class="mt-2 fade-in-up">
                  <div class="alert alert-success border-success mb-0 p-2 position-relative">
                    <h6 class="fw-bold text-success small mb-1">
                      <i class="fas fa-reply ms-1"></i> رد الغرفة:
                    </h6>
                    <p class="mb-2 text-dark small fw-bold">
                      {{ log.admin_response }}
                    </p>

                    <div v-if="!log.user_read_at" class="text-end border-top border-success-subtle pt-2">
                      <button 
                        @click="markResponseAsRead(log)" 
                        class="btn btn-sm btn-success shadow-sm w-100"
                        :disabled="log.processing"
                      >
                        <span v-if="log.processing" class="spinner-border spinner-border-sm"></span>
                        <span v-else><i class="fas fa-check-double ms-1"></i> استلام الرد</span>
                      </button>
                    </div>

                    <div v-else class="text-end text-success small opacity-75">
                      <i class="fas fa-check-circle ms-1"></i> تم الاطلاع
                    </div>

                  </div>
                </div>

              </div>

              <div v-if="complaints.length === 0" class="text-center text-muted py-4">
                <i class="fas fa-clipboard-list fa-2x mb-2 opacity-25"></i>
                <p class="small mb-0">لا توجد بلاغات مرسلة</p>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import api from '@/api/axios';
import UserWelcome from '@/components/UserWelcome.vue'; 

export default {
  name: "CommitteeOperations",
    components: { UserWelcome },
  data() {
    return {
      loading: false,
      sending: false,
      committee_name:'',
      // البيانات
      instructions: [],
      complaints: [],

      // النموذج
      form: {
        type: "",
        priority: "normal",
        description: ""
      }
    };
  },
  mounted() {
    this.fetchData();
     const user = localStorage.getItem('user'); // بيانات المستخدم
  
     
     if(user){
      this.committee_name =JSON.parse(user).committee_name
     }
  },
  methods: {
   async markResponseAsRead(log) {
  // تفعيل حالة التحميل للزر
  this.$set(log, 'processing', true);

  try {
    // استدعاء الرابط الذي أنشأناه سابقاً
    await api.post(`/committee/complaints/${log.id}/read-response`);
    
    // تحديث الواجهة فوراً
    log.user_read_at = new Date().toISOString();
    
    // رسالة تأكيد صغيرة (اختياري)
    // alert("تم تأكيد استلام الرد");

  } catch (error) {
    console.error(error);
    alert("حدث خطأ أثناء الاتصال");
  } finally {
    this.$set(log, 'processing', false);
  }
},
    // 1. جلب البيانات (التعليمات + البلاغات)
    async fetchData() {
      this.loading = true;
      try {
        const response = await api.get('/committee/operations');
        this.instructions = response.data.instructions;
        this.complaints = response.data.complaints;
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        this.loading = false;
      }
    },

    // 2. تسجيل قراءة التعليمات
    async markAsRead(msg) {
      // تحديث واجهة المستخدم فوراً (Optimistic UI) لسرعة الاستجابة
      this.$set(msg, 'processing', true); 

      try {
        const response = await api.post(`/committee/instructions/${msg.id}/read`);
        
        // تحديث البيانات من رد السيرفر
        msg.is_read = true;
        msg.read_at = response.data.read_at;
        
      } catch (error) {
        alert("حدث خطأ في الاتصال، حاول مرة أخرى");
      } finally {
        this.$set(msg, 'processing', false);
      }
    },

    // 3. إرسال بلاغ جديد
    async sendComplaint() {
      this.sending = true;
      try {
        const response = await api.post('/committee/complaints', this.form);
        
        // إضافة البلاغ الجديد للقائمة فوراً
        this.complaints.unshift(response.data.complaint);
        
        // تنظيف النموذج
        this.form.type = "";
        this.form.description = "";
        this.form.priority = "normal";
        
        alert("تم إرسال البلاغ بنجاح");
        
      } catch (error) {
        alert("فشل الإرسال، تأكد من الاتصال بالإنترنت");
      } finally {
        this.sending = false;
      }
    },

    // دوال تنسيق مساعدة
    getAlertClass(type) {
      if (type === 'urgent') return 'alert-danger border border-danger bg-danger-subtle'; // أحمر فاتح
      return 'alert-light border border-primary bg-white'; // أبيض بإطار أزرق
    },
    
    getStatusBadge(status) {
      const badges = {
        'sent': 'bg-secondary',
        'viewing': 'bg-warning text-dark',
        'resolved': 'bg-success'
      };
      return badges[status] || 'bg-secondary';
    },

    formatDate(dateString) {
      if(!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('ar-EG') + ' ' + date.toLocaleTimeString('ar-EG', {hour: '2-digit', minute:'2-digit'});
    },

    formatTime(dateString) {
      if(!dateString) return '';
      return new Date(dateString).toLocaleTimeString('ar-EG', {hour: '2-digit', minute:'2-digit'});
    }
  }
};
</script>
<style scoped>
/* تحسينات الموبايل */
@media (max-width: 768px) {
  .small-text-mobile {
    font-size: 0.9rem;
  }
  .btn-sm-mobile {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
}

/* تنسيق السكرول بار */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.border-top-warning { border-top: 4px solid #ffc107; }
.border-top-primary { border-top: 4px solid #0d6efd; }
.bg-danger-subtle { background-color: #fff5f5; }
</style>